import React, { memo } from "react";
import type { IconProps } from "./_IconProps";

const Quadrocopter = ({ color }: IconProps) => (
  <svg width={"24px"} height={"15px"} viewBox="0 0 24 15">
    <g
      id="Backoffice"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="BO---Site-KML" transform="translate(-554.000000, -771.000000)">
        <g id="ic/drone-q-W" transform="translate(554.000000, 765.000000)">
          <rect id="bounds" x="0" y="0" width="24" height="24"></rect>
          <path
            d="M9,7.81205465 C9,7.81205465 9.5522083,6.96280528 12,6.96280528 C14.4477917,6.96280528 15,7.81205465 15,7.81205465 C15,7.81205465 14.2653388,9.31523957 14,11.2705615 C13.7346612,13.2258835 14.3446339,14.715371 14.3446339,14.715371 C14.4304402,14.9726442 14.2889615,15.2510154 14.0227467,15.3390773 L12.0247488,16 L9.97488594,15.3352145 C9.71261368,15.2501576 9.5674464,14.9753772 9.64548682,14.7120927 C9.64548682,14.7120927 10.2486053,13.0817122 10,11.2497026 C9.75139475,9.41769304 9,7.81205465 9,7.81205465 Z"
            fill={color || "#FFFFFF"}
            fillRule="evenodd"
          ></path>
          <rect
            fill={color || "#FFFFFF"}
            fillRule="evenodd"
            transform="translate(16.630944, 10.136763) rotate(-20.000000) translate(-16.630944, -10.136763) "
            x="13.1309443"
            y="9.13676312"
            width="7"
            height="2"
          ></rect>
          <rect
            fill={color || "#FFFFFF"}
            fillRule="evenodd"
            transform="translate(7.630944, 10.136763) scale(-1, 1) rotate(-20.000000) translate(-7.630944, -10.136763) "
            x="4.13094432"
            y="9.13676312"
            width="7"
            height="2"
          ></rect>
          <path
            d="M10,18.0093689 C10,17.4519098 10.4433532,17 11.0093689,17 L12.9906311,17 C13.5480902,17 14,17.4433532 14,18.0093689 L14,19.9906311 C14,20.5480902 13.5566468,21 12.9906311,21 L11.0093689,21 C10.4519098,21 10,20.5566468 10,19.9906311 L10,18.0093689 Z M12,20 C12.5522847,20 13,19.5522847 13,19 C13,18.4477153 12.5522847,18 12,18 C11.4477153,18 11,18.4477153 11,19 C11,19.5522847 11.4477153,20 12,20 Z"
            fill={color || "#FFFFFF"}
            fillRule="evenodd"
          ></path>
          <rect
            fill={color || "#FFFFFF"}
            fillRule="evenodd"
            x="20"
            y="6"
            width="1"
            height="6"
          ></rect>
          <rect
            fill={color || "#FFFFFF"}
            fillRule="evenodd"
            x="11.5"
            y="12"
            width="1"
            height="6"
          ></rect>
          <rect
            fill={color || "#FFFFFF"}
            fillRule="evenodd"
            x="3"
            y="6"
            width="1"
            height="6"
          ></rect>
          <rect
            fill={color || "#FFFFFF"}
            fillRule="evenodd"
            transform="translate(3.500000, 6.500000) rotate(-90.000000) translate(-3.500000, -6.500000) "
            x="3"
            y="3"
            width="1"
            height="7"
          ></rect>
          <rect
            fill={color || "#FFFFFF"}
            fillRule="evenodd"
            transform="translate(20.500000, 6.500000) rotate(-90.000000) translate(-20.500000, -6.500000) "
            x="20"
            y="3"
            width="1"
            height="7"
          ></rect>
          <rect
            fill={color || "#FFFFFF"}
            fillRule="evenodd"
            x="2"
            y="7"
            width="3"
            height="4"
          ></rect>
          <rect
            fill={color || "#FFFFFF"}
            fillRule="evenodd"
            x="19"
            y="7"
            width="3"
            height="4"
          ></rect>
        </g>
      </g>
    </g>
  </svg>
);

export default memo(Quadrocopter);
